(function ($) {
  'use strict';

  window.ys.TourDeFrance2025 = new TDF2025();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('page-template-skoda-tour-de-france-2025')) {
    window.ys.TDF2025Contest = new TDF2025.Contest();
  }

  $(document).ready(function () {
    function initializeFlickity() {
      var $carousel = $('.promo-articles-carousel');
      var flkty;

      if (window.matchMedia('(max-width: 768px)').matches) {
        flkty = $carousel.flickity({
          wrapAround: true,
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 40,
          },
        });
      } else {
        flkty = $carousel.flickity({
          wrapAround: true,
          cellAlign: 'center',
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 40,
          },
        });
      }

      return flkty;
    }

    // Initialize Flickity on page load
    var flkty = initializeFlickity();

    // Re-initialize Flickity on window resize
    window.addEventListener('resize', function () {
      // Destroy the current instance and re-initialize
      $('.promo-articles-carousel').flickity('destroy');
      flkty = initializeFlickity();
    });
  });
}).bind(window)(jQuery);
